<template>
  <interview-layout :touch-and-validate="touchAndValidate">
    <!-- inner wrapper used for centering -->
    <div style="max-width: 440px;">
      <!-- title above form card -->
      <h1 class="px-4 pb-3 fade-in-up-enter-active animation-slowest delay-200 max-100">Huidige isolatie</h1>

      <!-- form 1 card -->
      <base-card class="w-100" color="alternate" :outer-padding="true" :stretch-inner="true" inner-class="vw-100">
        <base-form @submit="onSubmit">

          

          <!-- buttons -->
          <button-row class="mt-5">
            <base-button class="ms-auto" icon="bi-arrow-right" type="submit" :variant="nextButtonVariant" :disabled="v$.currentInsulation.$invalid">{{ nextButtonText }}</base-button>
          </button-row>
        </base-form>
        <!-- form card end -->
      </base-card>

      <button-row class="mt-2">
        <base-button variant="minimal-secondary" icon="bi-arrow-left" icon-position="start" @click="onPrev">Terug</base-button>
      </button-row>
      <!-- inner wrapper end -->
    </div>
  </interview-layout>
</template>

<script>
  import InterviewLayout from "@/views/layouts/InterviewLayout.vue"
  import BaseCard from '@/components/BaseCard.vue'
  import BaseForm from "@/components/BaseForm.vue"
  // import BaseInput from "@/components/BaseInput.vue"
  import BaseButton from "@/components/BaseButton.vue"
  import ButtonRow from "@/components/ButtonRow.vue"
  // import IssueFeedback from "@/components/IssueFeedback.vue"
  // import InfoItem from '@/components/InfoItem.vue';

  import { useAllStores } from "@/helpers/UseAllStores"
  import { CommonComposable } from "@/helpers/CommonComposable"
  import { FlowService } from "@/services/FlowService"

  export default {
    components: {
      InterviewLayout,
      BaseCard,
      BaseForm,
      // BaseInput,
      BaseButton,
      ButtonRow,
      // IssueFeedback,
      // InfoItem
    },
    setup(props, context) {
      return { ...CommonComposable(props, context), ...useAllStores() };
    },
    data() {
      return {
        yesNo: [
          {
            label: 'Ja',
            value: true
          },
          {
            label: 'Nee',
            value: false
          },
        ],
        yesNoDontKnow: [
          {
            label: 'Ja',
            value: 'Ja'
          },
          {
            label: 'Nee',
            value: 'Nee'
          },
          {
            label: 'Niet mogelijk',
            value: 'Niet mogelijk'
          },
          {
            label: 'Weet ik niet',
            value: 'Weet ik niet'
          }
        ],
        floorInsulationImpossibleOptions: [
          {
            label: 'Geen toegang tot kruipruimte',
            value: 'Geen toegang tot kruipruimte',
          },
          {
            label: 'Geen kruipruimte',
            value: 'Geen kruipruimte'
          },
          {
            label: 'Kruipruimte te laag',
            value: 'Kruipruimte te laag'
          },
          {
            label: 'Betonrot in de vloer',
            value: 'Betonrot in de vloer'
          },
        ]
      };
    },
    computed: {
      showAlternativeMeasureQuestions() {
        if (this.lead.currentInsulation.FloorInsulated === 'Ja' || this.lead.currentInsulation.FloorInsulated === 'Niet mogelijk') {
          return true;
        } else if (this.lead.currentInsulation.Participate === false && this.lead.currentInsulation.ConfirmNoParticipation) {
          return true;
        } else {
          return false;
        }
      },
      nextButtonVariant() {
        return this.lead.currentInsulation.Participate === false ? 'warning' : 'primary';
      },
      nextButtonText() {
        return this.lead.currentInsulation.Participate === false ? 'Afmelden voor regeling' : 'Volgende';
      }
    },
    watch: {
      // reset Participate if this.lead.currentInsulation.FloorInsulated = 'Ja' or 'Niet mogelijk'
      'lead.currentInsulation.FloorInsulated': function(newValue) {
        if (newValue === 'Ja' || newValue === 'Niet mogelijk') {
          this.lead.currentInsulation.Participate = null;
        }
      },
      // watch Participate and set ConfirmNoParticipation to null if Participate is true
      'lead.currentInsulation.Participate': function(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.lead.currentInsulation.ConfirmNoParticipation = null;
        }
      },
    },
    methods: {
      touchAndValidate() {
        this.v$.currentInsulation.$touch();
        return !this.v$.currentInsulation.$invalid;
      },
      onSubmit() {
        if (this.touchAndValidate()) {
          FlowService.pushNext(this);
        }
      },
      onPrev() {
        FlowService.pushPrev(this);
      },
      breakPoints() {
        if (window.innerWidth > 500) {
          this.btnDirection = 'column';
          this.maxCols = 99;
        } else {
          this.btnDirection = 'row';
          this.maxCols = 1;
        }
      }
    }
  }
</script>

<style lang="scss">
</style>